import TextCreate from 'core/display/simple/Text'
import { LocalizationService } from 'services/LocalizationService'

export default class ReplaceText extends TextCreate{
  constructor(data) {
    super(data)
    this.template = LocalizationService.get(data.text)
    this.replace = (...args) => {
      super.update(this.template.replace(/{(\d+)}/g, (all, i) => args[i]))
    }
  }
}
